import React from "react";
import ViewCard from "./ViewCard";
import CareerHeader from "../CareerHeader";
import ViewList from "./job-career-view/ViewList";

function CareerViewList() {
  return (
    <div className=" flex flex-col h-[100vh] overflow-y-scroll  w-full">
      {" "}
      <CareerHeader hide={true} />
      <div className=" bg-[#F9F9F9]  lg:px-[22.5rem] px-3">
        <ViewCard />
        <div className="my-[1.5rem]">
          <ViewList />
        </div>
      </div>
    </div>
  );
}

export default CareerViewList;
